"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.m365SearchMeSubNode = exports.meProjectTypeNode = exports.tabProjectTypeNode = exports.botProjectTypeNode = exports.notificationBotTriggerNode = exports.inputOrSearchAPISpecNode = exports.apiSpecWithSearchNode = exports.apiSpecNode = exports.TeamsProjectTypeOptions = exports.teamsAppProjectNode = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../common/localizeUtils");
const create_1 = require("../../create");
const questionNames_1 = require("../../questionNames");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const featureFlags_1 = require("../../../common/featureFlags");
function teamsAppProjectNode(platform) {
    return {
        // project-type = Teams App
        condition: { equals: ProjectTypeOptions_1.ProjectTypeOptions.teamsAppOptionId },
        data: {
            name: questionNames_1.QuestionNames.TeamsAppType,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.teamsApp.title"),
            type: "singleSelect",
            staticOptions: [
                TeamsProjectTypeOptions.bot(platform),
                TeamsProjectTypeOptions.tab(platform),
                TeamsProjectTypeOptions.me(platform),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.placeholder"),
        },
        children: [botProjectTypeNode(), tabProjectTypeNode(), meProjectTypeNode()],
    };
}
exports.teamsAppProjectNode = teamsAppProjectNode;
class TeamsProjectTypeOptions {
    static tab(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: TeamsProjectTypeOptions.tabOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(browser) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.TabOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.tab.detail"),
        };
    }
    static bot(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: TeamsProjectTypeOptions.botOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(hubot) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.detail"),
        };
    }
    static me(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: TeamsProjectTypeOptions.meOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(symbol-keyword) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.messageExtension.copilotEnabled.detail"),
        };
    }
}
exports.TeamsProjectTypeOptions = TeamsProjectTypeOptions;
TeamsProjectTypeOptions.tabOptionId = "tab-type";
TeamsProjectTypeOptions.botOptionId = "bot-type";
TeamsProjectTypeOptions.meOptionId = "me-type";
function apiSpecNode(condition) {
    return {
        condition: condition,
        data: { type: "group", name: questionNames_1.QuestionNames.FromExistingApi },
        children: [
            {
                data: (0, create_1.apiSpecLocationQuestion)(),
            },
            {
                condition: (inputs) => {
                    return !inputs[questionNames_1.QuestionNames.ActionManifestPath];
                },
                data: (0, create_1.apiOperationQuestion)(),
            },
        ],
    };
}
exports.apiSpecNode = apiSpecNode;
function apiSpecWithSearchNode() {
    return {
        data: { type: "group", name: questionNames_1.QuestionNames.FromExistingApi },
        condition: { equals: "api-spec" },
        children: [inputOrSearchAPISpecNode()],
    };
}
exports.apiSpecWithSearchNode = apiSpecWithSearchNode;
function inputOrSearchAPISpecNode() {
    return {
        data: (0, create_1.apiSpecTypeSelectQuestion)(),
        condition: (inputs) => {
            return featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaNPMIntegration);
        },
        children: [
            {
                condition: { equals: "enter-url-or-open-local-file" },
                data: (0, create_1.apiSpecLocationQuestion)(),
                children: [
                    {
                        condition: (inputs) => {
                            return !inputs[questionNames_1.QuestionNames.ActionManifestPath];
                        },
                        data: (0, create_1.apiOperationQuestion)(true, true),
                    },
                ],
            },
            {
                condition: { equals: "search-api" },
                data: (0, create_1.searchOpenAPISpecQueryQuestion)(),
                children: [
                    {
                        data: (0, create_1.selectOpenApiSpecQuestion)(),
                    },
                    {
                        condition: (inputs) => {
                            return !!inputs[questionNames_1.QuestionNames.SelectOpenApiSpec];
                        },
                        data: (0, create_1.apiOperationQuestion)(true, true),
                    },
                ],
            },
        ],
    };
}
exports.inputOrSearchAPISpecNode = inputOrSearchAPISpecNode;
function notificationBotTriggerNode(platform = teamsfx_api_1.Platform.VSCode) {
    return {
        condition: { equals: CapabilityOptions_1.BotCapabilityOptions.notificationBotId },
        data: {
            name: questionNames_1.QuestionNames.BotTrigger,
            title: (0, localizeUtils_1.getLocalizedString)("plugins.bot.questionHostTypeTrigger.title"),
            type: "singleSelect",
            cliDescription: "Specifies the trigger for `Chat Notification Message` app template.",
            staticOptions: [
                platform === teamsfx_api_1.Platform.VS
                    ? CapabilityOptions_1.NotificationBotOptions.appServiceForVS()
                    : CapabilityOptions_1.NotificationBotOptions.appService(),
                CapabilityOptions_1.NotificationBotOptions.functionsHttpAndTimerTrigger(),
                CapabilityOptions_1.NotificationBotOptions.functionsHttpTrigger(),
                CapabilityOptions_1.NotificationBotOptions.functionsTimerTrigger(),
            ],
            default: platform === teamsfx_api_1.Platform.VS
                ? CapabilityOptions_1.NotificationBotOptions.appServiceForVS().id
                : CapabilityOptions_1.NotificationBotOptions.appService().id,
            placeholder: (0, localizeUtils_1.getLocalizedString)("plugins.bot.questionHostTypeTrigger.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
    };
}
exports.notificationBotTriggerNode = notificationBotTriggerNode;
function botProjectTypeNode() {
    return {
        // project-type = Bot
        condition: { equals: TeamsProjectTypeOptions.botOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.BotCapabilityOptions.basicBot(),
                CapabilityOptions_1.BotCapabilityOptions.notificationBot(),
                CapabilityOptions_1.BotCapabilityOptions.commandBot(),
                CapabilityOptions_1.BotCapabilityOptions.workflowBot(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [notificationBotTriggerNode()],
    };
}
exports.botProjectTypeNode = botProjectTypeNode;
function tabProjectTypeNode(platform = teamsfx_api_1.Platform.VSCode) {
    return {
        // project-type = Tab
        condition: { equals: TeamsProjectTypeOptions.tabOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.tab.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.TabCapabilityOptions.nonSsoTab(),
                CapabilityOptions_1.TabCapabilityOptions.m365SsoLaunchPage(),
                CapabilityOptions_1.TabCapabilityOptions.dashboardTab(),
                CapabilityOptions_1.TabCapabilityOptions.SPFxTab(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            {
                //SPFx sub-tree
                condition: { equals: CapabilityOptions_1.TabCapabilityOptions.SPFxTab().id },
                data: (0, create_1.SPFxSolutionQuestion)(),
                children: [
                    {
                        data: { type: "group" },
                        children: [
                            { data: (0, create_1.SPFxPackageSelectQuestion)() },
                            { data: (0, create_1.SPFxFrameworkQuestion)() },
                            { data: (0, create_1.SPFxWebpartNameQuestion)() },
                        ],
                        condition: { equals: "new" },
                    },
                    {
                        data: (0, create_1.SPFxImportFolderQuestion)(),
                        condition: { equals: "import" },
                    },
                ],
            },
        ],
    };
}
exports.tabProjectTypeNode = tabProjectTypeNode;
function meProjectTypeNode() {
    return {
        // project-type = Messaging Extension
        condition: { equals: TeamsProjectTypeOptions.meOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.messageExtension.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.MeCapabilityOptions.m365SearchMe(),
                CapabilityOptions_1.MeCapabilityOptions.collectFormMe(),
                CapabilityOptions_1.MeCapabilityOptions.linkUnfurling(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [m365SearchMeSubNode()],
    };
}
exports.meProjectTypeNode = meProjectTypeNode;
function m365SearchMeSubNode() {
    return {
        // Search ME sub-tree
        condition: { equals: CapabilityOptions_1.MeCapabilityOptions.m365SearchMe().id },
        data: {
            name: questionNames_1.QuestionNames.MeArchitectureType,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.meArchitecture.title"),
            cliDescription: "The authentication type for the API.",
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.MeArchitectureOptions.newApi(),
                CapabilityOptions_1.MeArchitectureOptions.openApiSpec(),
                CapabilityOptions_1.MeArchitectureOptions.botMe(),
            ],
            default: CapabilityOptions_1.MeArchitectureOptions.newApi().id,
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotExtension.placeholder"),
            forgetLastValue: true,
            skipSingleOption: true,
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            {
                condition: { equals: CapabilityOptions_1.MeArchitectureOptions.newApi().id },
                data: {
                    type: "singleSelect",
                    name: questionNames_1.QuestionNames.ApiAuth,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiMessageExtensionAuth.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiMessageExtensionAuth.placeholder"),
                    staticOptions: [
                        CapabilityOptions_1.ApiAuthOptions.none(true),
                        CapabilityOptions_1.ApiAuthOptions.bearerToken(),
                        CapabilityOptions_1.ApiAuthOptions.microsoftEntra(true),
                    ],
                    default: CapabilityOptions_1.ApiAuthOptions.none(true).id,
                    onDidSelection: CapabilityOptions_1.setTemplateName,
                },
            },
            apiSpecNode({ equals: CapabilityOptions_1.MeArchitectureOptions.openApiSpec().id }),
        ],
    };
}
exports.m365SearchMeSubNode = m365SearchMeSubNode;
//# sourceMappingURL=teamsProjectTypeNode.js.map